import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Collapse, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  AddBoxOutlined as PlusIcon,
  IndeterminateCheckBoxOutlined as MinusIcon,
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 2),
    backgroundColor: '#f2f4f8',
    color: '#000',
    borderRadius: '8px',
    marginBottom: 10,
  },
  handler: {
    padding: 0,
    cursor: 'pointer',
  },
  expandedHandlerIcon: {
    minWidth: 0,
    cursor: 'pointer',
    '& svg': {
      color: '#999191',
    },
  },
  title: {
    color: '#586065',
    '& .MuiTypography-root': {
      fontWeight: 'bold',
    },
  },
}));

const Accordion = (props) => {
  const { title, children } = props;
  const [expanded, setExpanded] = useState(false);
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ListItem
        className={classes.handler}
        onClick={() => setExpanded(!expanded)}
      >
        <ListItemText className={classes.title} primary={title} />
        <ListItemIcon className={classes.expandedHandlerIcon}>
          {expanded ? <MinusIcon /> : <PlusIcon />}
        </ListItemIcon>
      </ListItem>
      <Collapse in={expanded} timeout='auto' unmountOnExit>
        {children}
      </Collapse>
    </div>
  );
};

export default Accordion;
